import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DetailRoutingModule,detailComponents } from './detail-episode.routing';


import { SharedModule } from '../../shared/shared.module';
import { MoviesService } from "src/app/views/movies/movies.servies";
import { AssetsService } from 'src/app/core/services/assets.service';

import { livetvService } from "src/app/views/livetv/livetv.servies";
import { ClipboardModule } from 'ngx-clipboard';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';



@NgModule({
  declarations: [detailComponents],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DetailRoutingModule,
    SharedModule,
    ClipboardModule,
    NgbModule,
    InfiniteScrollModule,
  ],
  providers:[AssetsService, livetvService]
})
export class DetailModule { }
